import { render } from "./BuyerLocation.vue?vue&type=template&id=02a63dc5&scoped=true&ts=true&lang=pug"
import script from "./BuyerLocation.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuyerLocation.vue?vue&type=script&lang=ts&setup=true"

import "./BuyerLocation.vue?vue&type=style&index=0&id=02a63dc5&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a63dc5"]])

export default __exports__